import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, withStyles, CircularProgress } from '@material-ui/core';

export const styles = {
  modal: {
    margin: 'auto',
    paddingRight: '5%',
    top: '40%',
    width: 0,
  },
};

export function LoadingImpl({ isOpen }) {
  return (
    <Modal
      open={isOpen}
      style={styles.modal}
      disableAutoFocus
      disableBackdropClick
    >
      <CircularProgress
        color="primary"
        size={100}
      />
    </Modal>
  );
}

const loadingProps = {
  isOpen: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    modal: PropTypes.string.isRequired,
  }).isRequired,
};

export {
  loadingProps,
};

LoadingImpl.propTypes = loadingProps;

export function mapStateToProps(state) {
  return {
    isOpen: state.loading.loading,
  };
}

export default connect(mapStateToProps)(withStyles(styles)(LoadingImpl));
